export const LIMITS_BASE = '/partner-management-proxy/api/v2/partners/carrierAccounts/limitsV2';
